import React from 'react'
import {
  AuditIcon,
  BusinessApplicationsIcon,
  BusinessBuildingIcon,
  BusinessOptimizationIcon,
  BusinessStrategyIcon,
  CoinsIcon,
  CollaborationIcon,
  DataCloudIcon,
  DataDigitalServicesIcon,
  DesktopDashboardIcon,
  DueDiligenceIcon,
  FamilyOfficesIcon,
  FederalTaxIcon,
  FinancialConsultingIcon,
  FinancialTalkBubblesIcon,
  GavelStrikeIcon,
  GearCircuitryIcon,
  GearConferenceIcon,
  GearDigitizationIcon,
  GlobalCircumnavigateIcon,
  GlobalStrategyIcon,
  MagnifyingGlassDocumentIcon,
  MagnifyingGlassFingerprintIcon,
  ManagedCloudITIcon,
  ManagedServicesIcon,
  ManagedTechnologyServicesIcon,
  ManagementConsultingIcon,
  MergerIcon,
  MergersAndAcquisitionsIcon,
  MicrosoftIcon,
  NetsuiteIcon,
  PersonListeningIcon,
  PrivateClientServicesIcon,
  ProtectionIcon,
  RiskConsultingIcon,
  StateAndLocalTaxIcon,
  StrategyIcon,
  TaxDocumentIcon,
  ToDoListIcon,
  TransactionIcon,
} from '@rsmus/myrsm-icons'
import { useFeatureFlag } from '../../../utils/hooks/useFeatureFlag'
import { TagIconMap } from '../types'

const ServiceLinesIconMapper = () => {
  const userRedesignFeatureEnabled = useFeatureFlag('UserProfile_Redesign')

  const tagIconMap: TagIconMap = userRedesignFeatureEnabled
    ? {
        // this list is incomplete and will be updated in a later story
        audit: <AuditIcon />,
        'business-applications': <BusinessApplicationsIcon />,
        'business-optimization': <BusinessOptimizationIcon />,
        'business-strategy': <BusinessStrategyIcon />,
        'cloud-services': <ManagedCloudITIcon />,
        'data-digital-services': <DataDigitalServicesIcon />,
        'due-diligence': <DueDiligenceIcon />,
        'family-office-services': <FamilyOfficesIcon />,
        'federal-tax': <FederalTaxIcon />,
        'financial-consulting': <FinancialConsultingIcon />,
        'global-strategy': <GlobalStrategyIcon />,
        'managed-services': <ManagedServicesIcon />,
        'managed-technology-services': <ManagedTechnologyServicesIcon />,
        'management-consulting': <ManagementConsultingIcon />,
        'mergers-acquisition': <MergersAndAcquisitionsIcon />,
        microsoft: <MicrosoftIcon />,
        netsuite: <NetsuiteIcon />,
        'private-client-services': <PrivateClientServicesIcon />,
        'risk-consulting': <RiskConsultingIcon />,
        'state-local-tax': <StateAndLocalTaxIcon />,
      }
    : {
        audit: <MagnifyingGlassDocumentIcon />,
        'business-applications': <BusinessBuildingIcon />,
        'business-strategy': <StrategyIcon />,
        'business-tax': <TaxDocumentIcon />,
        'cybersecurity-risk': <ProtectionIcon />,
        'data-digital-services': <DesktopDashboardIcon />,
        'digital-transformation': <GearDigitizationIcon />,
        'due-diligence': <ToDoListIcon />,
        'family-office-services': <GearConferenceIcon />,
        'financial-consulting': <FinancialTalkBubblesIcon />,
        'financial-management': <CoinsIcon />,
        'global-services': <GlobalCircumnavigateIcon />,
        'managed-services': <GearCircuitryIcon />,
        'managed-technology-services': <DataCloudIcon />,
        'management-consulting': <CollaborationIcon />,
        'mergers-acquisition': <MergerIcon />,
        'private-client-services': <PersonListeningIcon />,
        'regulatory-compliance': <GavelStrikeIcon />,
        'risk-consulting': <MagnifyingGlassFingerprintIcon />,
        'transaction-advisory': <TransactionIcon />,
      }

  return tagIconMap
}

export default ServiceLinesIconMapper
